import React, {Component} from 'react';
import {connect} from 'react-redux';
import AccountProfileController from '../components/account/AccountProfileController'
import Load from '../components/Load';
import {sendVerificationEmail} from "../actions/index";

class AccountContainer extends Component {

    render() {

        if (!this.props.user) {return (<Load/>)}

        return (
            <div className="main-container">
                <div className="account-container">
                    <AccountProfileController initialValues={{
                                                  name: this.props.user.name,
                                                  phone: this.props.user.phone
                                              }}
                                              user={this.props.user}
                                              dispatch={this.props.dispatch}
                                              onEmailVerificationClick={() => {this.props.dispatch(sendVerificationEmail())}}/>
                </div>
            </div>
        );
    }
}

export default AccountContainer = connect((state) => {
    return {
        user: (state.data || {}).ETMSUser,
    }
})(AccountContainer);


// WEBPACK FOOTER //
// ./src/containers/AccountContainer.jsx